import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const customPackageApi = createApi({
  reducerPath: 'customPackageApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin/custom-packages`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('prona_userToken');
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ['CustomPackage'],
  endpoints: (build) => ({
    getCustomPackages: build.query({
      query: (params = {}) => {
        const qs = new URLSearchParams(params).toString();
        return qs ? `/?${qs}` : '/';
      },
      providesTags: ['CustomPackage'],
    }),
    getTemplates: build.query({
      query: () => '/templates',
      providesTags: ['CustomPackage'],
    }),
    getCustomPackageById: build.query({
      query: (id) => `/${id}`,
      providesTags: ['CustomPackage'],
    }),
    searchUsers: build.query({
      query: (q) => `/users/search?q=${encodeURIComponent(q)}`,
    }),
    createCustomPackage: build.mutation({
      query: (data) => ({ url: '/', method: 'POST', body: data }),
      invalidatesTags: ['CustomPackage'],
    }),
    updateCustomPackage: build.mutation({
      query: ({ id, ...data }) => ({ url: `/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['CustomPackage'],
    }),
    assignUsers: build.mutation({
      query: ({ id, ...data }) => ({ url: `/${id}/assign`, method: 'POST', body: data }),
      invalidatesTags: ['CustomPackage'],
    }),
    deleteCustomPackage: build.mutation({
      query: (id) => ({ url: `/${id}`, method: 'DELETE' }),
      invalidatesTags: ['CustomPackage'],
    }),
  }),
});

export const {
  useGetCustomPackagesQuery,
  useGetTemplatesQuery,
  useGetCustomPackageByIdQuery,
  useLazySearchUsersQuery,
  useCreateCustomPackageMutation,
  useUpdateCustomPackageMutation,
  useAssignUsersMutation,
  useDeleteCustomPackageMutation,
} = customPackageApi;
